<template>
  <ContentSection>
    <Container>
      <!-- HEADER -->
      <h2 v-if="data.heading" class="whitespace-pre-wrap font-semibold typo-h3" v-html="data.heading" />

      <!-- TEXT -->
      <div v-if="data.text" class="mt-4 max-w-text typo-lead" v-html="data.text" />

      <!-- FROM -->
      <FormBuilder
        :class="{ 'mt-7': data.heading || data.text }"
        :form-blueprint="data.contact_form"
        :text-submit-button="data.text_submit_button"
        :text-success="data.text_success"
        :text-error="data.text_error"
      />
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
defineProps({
  data: {
    type: Object,
    required: true,
  },
})

provide('shouldTranslate', true)
</script>
